import appConf from '../app-conf'
const setup = appConf[process.env.REACT_APP_CLIENT]
const environment = process.env.NODE_ENV
const project = 'Change Password'
const server = null
const service = null

const config = {
  details: {
    project,
    server,
    environment,
    service,
  },
  application: {
    cms: {
      api: {
        endpoints: {
          deletecontent: {
            headers: {
              'Content-Type': 'application/json',
            },
            url: setup.setup.api.cms.url[environment] + '/mastercontents',
            // url: setup.setup.api.cms.url[env] + '/auth/local',
            method: 'DELETE',
          },
          approvecontent: {
            headers: {
              'Content-Type': 'application/json',
            },
            url: setup.setup.api.cms.url[environment] + '/mastercontents',
            // url: setup.setup.api.cms.url[env] + '/auth/local',
            method: 'PUT',
          },
          updateflagtopending: {
            headers: {
              'Content-Type': 'application/json',
            },
            url: setup.setup.api.cms.url[environment] + '/mastercontents',
            // url: setup.setup.api.cms.url[env] + '/auth/local',
            method: 'PUT',
          },
        },
      },
      objects: {
        comment: {
          name: 'comment',
          initial: '',
          label: 'Comments',
          helperText: false,
          rules: false,
        },
      },
    },
  },
  routes: {
    label: 'Edit Content Page',
    prefix: '/content/detail/noti/:id',
  },
  environment,
  setup,
}

export default config
